/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentTrackerSettingsRequest = {
    defaultCurrency: ShipmentTrackerSettingsRequest.defaultCurrency;
    units: ShipmentTrackerSettingsRequest.units;
    dateFormat: ShipmentTrackerSettingsRequest.dateFormat;
    timezone: ShipmentTrackerSettingsRequest.timezone;
};
export namespace ShipmentTrackerSettingsRequest {
    export enum defaultCurrency {
        EUR = 'EUR',
        USD = 'USD',
    }
    export enum units {
        METRIC = 'metric',
        IMPERIAL = 'imperial',
    }
    export enum dateFormat {
        DD_MM_YYYY = 'DD/MM/YYYY',
        MM_DD_YYYY = 'MM/DD/YYYY',
        YYYY_MM_DD = 'YYYY-MM-DD',
    }
    export enum timezone {
        EUROPE_BERLIN = 'Europe/Berlin',
        EUROPE_LONDON = 'Europe/London',
        AMERICA_NEW_YORK = 'America/New_York',
        UTC = 'UTC',
    }
}

